module.exports = __webpack_public_path__ + "media/img/deyasa-346studio-65885ec3.jpg";